import Vue from 'vue';
import {getAllCampaigns} from '@/utils/api';

const moment = require('moment');

const state = {
  allCampaigns: [],
  lastUpdate: null
};

// actions
const actions = {
  updateCampaigns({commit, state}, {charity_id, force = false}) {
    return new Promise((resolve) => {

      //cache for 3 minutes
      if (state.lastUpdate === null || force || moment().diff(state.lastUpdate, 'seconds') > 60 * 3) {
        getAllCampaigns(true, charity_id).then(campaigns => {
          commit('setCampaigns', campaigns);
          resolve();
        });
      }
      else {
        resolve();
      }
    });
  },
};

// mutations
const mutations = {
  setCampaigns(state, allCampaigns) {
    Vue.set(state, 'lastUpdate', moment());
    Vue.set(state, 'allCampaigns', allCampaigns);
  },
  resetCache(state) {
    Vue.set(state, 'lastUpdate', null);
    Vue.set(state, 'allCampaigns', []);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};